import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthEventsService {

  // evento logout
  private logoutSubject = new Subject<void>();

  logout$ = this.logoutSubject.asObservable();

  // emitir logout
  emitLogout(): void {
    this.logoutSubject.next();
  }

}
